module.exports = __webpack_public_path__ + "static/media/kh.cc77c34d.svg";